import Resource from './Resource';
import EventBus from 'App/services/EventBus';
import { STYLE } from 'Store/reducers/SystemNotificationReducer';

export type ResetScoreData = {
	clientId?: number;
	contactId?: number;
	userId: number;
	synch: boolean;
	customerId?: number;
};

class ResetScore extends Resource {
	constructor() {
		super('resetScore');

		// @ts-expect-error notifications is untyped on the JS base class
		this.notifications.resetError = () => ({
			title: 'default.error',
			body: 'saveError.unassign',
			style: STYLE.ERROR,
			icon: 'times'
		});
	}

	reset(customerId: number, data: ResetScoreData): Promise<void> {
		return this._postRequest('', data, {
			_url: `${customerId}/function/resetScore`,
			methodName: 'reset'
		}).then(
			() => {
				EventBus.broadcast('account.resetScore', data.clientId);
			},
			// The Angular factory resolved instead of rejecting once it had shown the error
			// notification. Kept, so a failed reset still lets its callers finish.
			() => {}
		);
	}
}

export default new ResetScore();
